module.exports = __webpack_public_path__ + "static/img/policy.29066b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/policy.png
// module id = 9oXb
// module chunks = 29